module.exports = __webpack_public_path__ + "static/apple-touch-icon.df190b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/apple-touch-icon.png
// module id = 1000
// module chunks = 79611799117203